import websocketProxyInstance from './instance'

const getConnections = () => websocketProxyInstance.get('/connections', { timeout: 10000 })

export default getConnections
